import React from 'react';
import { createCredit, useCredit } from 'api';
import FormError from '../FormError';
import { transformErrorResponse } from 'helpers/errors';
import { findPurchase } from 'actions/purchases';
import { connect } from 'react-redux';
import AdjustmentCreditConfirmModal from './AdjustmentCreditConfirmModal';
import ModalContainer from 'react-modal-promise';

class AdjustmentCredit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSent: false,
      error: undefined,
      showModal: false,
    };
  }

  async createAdjustmentCredit(amount, userProfile) {
    try {
      const {
        status,
        data: { id },
      } = await createCredit({
        credit_owed: amount,
        user_profile: userProfile,
        description: 'A Wing Agent gave you an adjustment credit.',
        credit_type: 'adjust',
      });
      if (status === 201) {
        try {
          const { status: useCreditStatus } = await useCredit({
            purchaseId: this.props.purchaseId,
            creditId: id,
          });
          if (useCreditStatus === 200) {
            setTimeout(
              () => this.props.findPurchase(this.props.purchaseId),
              1000,
            );
            this.setState({
              isSent: true,
              error: undefined,
            });
          }
        } catch ({ response: userCreditResponse }) {
          const error = transformErrorResponse(userCreditResponse.data);
          this.setState({
            error,
            isSent: false,
          });
        }
      }
    } catch ({ response }) {
      const error = transformErrorResponse(response.data);
      this.setState({
        error,
        isSent: false,
      });
    }
  }

  async handleOpenModal() {
    await this.setState({ showModal: true });
    const confirmResult = await AdjustmentCreditConfirmModal({
      open: this.state.showModal,
    });
    await this.setState({ showModal: false });
    if (confirmResult) {
      const { amount, userProfile } = this.props;
      await this.createAdjustmentCredit(amount, userProfile);
    }
  }

  render() {
    const { isSent, error } = this.state;
    return (
      <React.Fragment>
        <button
          onClick={() => {
            this.handleOpenModal();
          }}
          className="btn mar-t"
          disabled={isSent}
        >
          Create Adjustment Credit
        </button>
        {isSent ? <div>Adjustment credit has been created.</div> : null}
        {error ? <FormError error={error} /> : null}
        <ModalContainer />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  findPurchase,
};

export default connect(null, mapDispatchToProps)(AdjustmentCredit);
